import React, {ChangeEvent} from 'react'


interface FormFieldProps {
  name: string
  type?: string
  value: string
  placeholder?: string
  label: string
  onChange: (evt: ChangeEvent<HTMLInputElement>) => void
}

const FormField = ({type, name, label, placeholder, value, onChange}: FormFieldProps) => (
  <div className="my-2">
    <label htmlFor={name} className="sr-only">{label}</label>
    <input id={name} name={name} type={type || 'text'} autoComplete={type === 'password' ? 'current-password' : name} required
           onChange={onChange} value={value}
           className="relative rounded block w-full px-3 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
           placeholder={placeholder || label}/>
  </div>
)

export default FormField;
